var map = {
	"./Arrow.png": 295,
	"./Call.png": 296,
	"./Close.png": 726,
	"./DOC.png": 727,
	"./LeadProjectImg.png": 87,
	"./Login_background.png": 728,
	"./Mail.png": 297,
	"./Meeting.png": 298,
	"./PDF.png": 729,
	"./PPT.png": 730,
	"./Success.png": 299,
	"./activity.png": 731,
	"./admin.png": 732,
	"./background.png": 351,
	"./calendar.png": 352,
	"./campaigns.png": 733,
	"./cancel.png": 353,
	"./company.png": 734,
	"./contact.png": 735,
	"./create.png": 354,
	"./dashboard.png": 736,
	"./delete.png": 737,
	"./handShake.png": 738,
	"./help.png": 355,
	"./home.png": 739,
	"./lead.png": 740,
	"./leadDetails.png": 356,
	"./leadProjects.png": 357,
	"./leadx_logo.png": 741,
	"./logo.png": 742,
	"./news.png": 743,
	"./newsCard.png": 358,
	"./newsImg.png": 744,
	"./notification.png": 359,
	"./sales team.png": 745,
	"./salesfeed.png": 746,
	"./star.png": 360,
	"./sync.png": 361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 228;